module.exports = __webpack_public_path__ + "assets/webgl/ConcreteFloor_Albedo.jpg.8e26e276.webp";